// Public download URL for the NearbyDeals Android app (APK)
export const APK_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_hyperlocal-shop-33/artifacts/elfi9v94_nearbydeals%20new23.apk";
export const APK_FILENAME = "nearbydeals.apk";
